import { Button } from '../../../../components';

interface InlineEditorActionsProps {
  /** Translation function of the editor's namespace, providing `actions.*` labels. */
  t: (key: string) => string;
  saving: boolean;
  onCancel: () => void;
  onSave: () => Promise<void>;
}

/** Cancel and save buttons of an inline editor that does not register its save with a host. */
export function InlineEditorActions({ t, saving, onCancel, onSave }: InlineEditorActionsProps) {
  return (
    <div className='flex justify-end gap-sm'>
      <Button variant='ghost' size='sm' onClick={onCancel} disabled={saving}>
        {t('actions.cancel')}
      </Button>
      <Button variant='primary' size='sm' onClick={() => void onSave()} disabled={saving}>
        {saving ? t('actions.saving') : t('actions.save')}
      </Button>
    </div>
  );
}
